(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSlider(root) {
    if (root.dataset.msInit) return;
    root.dataset.msInit = '1';

    var track = root.querySelector('[data-ms-track]');
    if (!track) return;

    var full = root.dataset.msSlider === 'full';
    var prev = root.querySelector('[data-ms-prev]');
    var next = root.querySelector('[data-ms-next]');
    var dotsWrap = root.querySelector('[data-ms-dots]');
    var slides = Array.prototype.slice.call(track.children);
    var dots = [];
    var timer = null;
    var ticking = false;

    function index() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    function goTo(i) {
      var count = slides.length;
      i = (i + count) % count;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }

    function pageStep() {
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var width = slides[0].getBoundingClientRect().width + gap;
      return width * Math.max(1, Math.floor(track.clientWidth / width));
    }

    function update() {
      ticking = false;
      if (full) {
        var current = index();
        dots.forEach(function (dot, k) {
          dot.classList.toggle('is-active', k === current);
          dot.setAttribute('aria-current', k === current ? 'true' : 'false');
        });
      } else {
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
    }

    if (full && dotsWrap && slides.length > 1) {
      slides.forEach(function (_, k) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ms-dot';
        dot.setAttribute('aria-label', 'Slayt ' + (k + 1));
        dot.addEventListener('click', function () { goTo(k); });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        if (full) goTo(index() - 1);
        else track.scrollBy({ left: -pageStep(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        if (full) goTo(index() + 1);
        else track.scrollBy({ left: pageStep(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });
    window.addEventListener('resize', update);

    if (full && root.dataset.msAutoplay === 'true' && !reduceMotion && slides.length > 1) {
      var delay = (parseInt(root.dataset.msSpeed, 10) || 6) * 1000;
      var start = function () {
        stop();
        timer = setInterval(function () { goTo(index() + 1); }, delay);
      };
      var stop = function () {
        if (timer) clearInterval(timer);
        timer = null;
      };
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      root.addEventListener('touchstart', stop, { passive: true });
      start();
    }

    update();
  }

  function initCountdown(el) {
    if (el.dataset.msInit) return;
    el.dataset.msInit = '1';

    var end = new Date(String(el.dataset.msCountdown).trim().replace(' ', 'T')).getTime();
    if (isNaN(end)) {
      el.hidden = true;
      return;
    }

    var parts = {
      d: el.querySelector('[data-d]'),
      h: el.querySelector('[data-h]'),
      m: el.querySelector('[data-m]'),
      s: el.querySelector('[data-s]')
    };
    var timer = null;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        el.hidden = true;
        if (timer) clearInterval(timer);
        return;
      }
      var s = Math.floor(left / 1000);
      parts.d.textContent = pad(Math.floor(s / 86400));
      parts.h.textContent = pad(Math.floor((s % 86400) / 3600));
      parts.m.textContent = pad(Math.floor((s % 3600) / 60));
      parts.s.textContent = pad(s % 60);
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-ms-slider]').forEach(initSlider);
    root.querySelectorAll('[data-ms-countdown]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('[data-ms-slider="full"]');
    if (!root) return;
    var track = root.querySelector('[data-ms-track]');
    if (track) track.scrollTo({ left: event.target.offsetLeft, behavior: 'smooth' });
  });
})();
